import {useEffect, useRef, useState} from 'react'
import ModalForm from 'src/biz/ModalForm'
import Search from 'src/biz/Search'
import Table from 'src/biz/Table'
import type {SchemaType} from 'src/biz/types'
import {exportExcel} from 'src/biz/utils'
import http from 'src/biz/utils/request'
import {message} from 'src/ui'
import Provider from 'src/ui/Provider'
import styles from './index.module.scss'
// table search组件
export const SchemaForm: React.FC<SchemaType> = props => {
  console.log('SchemaForm props', props)
  const [pageInfo, setPageInfo] = useState({page: 1, pageSize: 20})
  const [total, setTotal] = useState(0)
  const [showAddModal, setshowAddModall] = useState(false)
  const tableRef: any = useRef(null)
  const searchRef: any = useRef(null)
  const {searchJson, tableJson, apiList, children, addJson} = props
  const [dataSource, setDataSource] = useState([])
  useEffect(() => {
    initRef()
  }, [])
  const initRef = () => {
    tableRef.current = {page: 1, pageSize: 20, sortType: 0, sortKey: ''}
  }
  const resetPageParmams = () => {
    tableRef.current = {
      page: 1,
      pageSize: 20,
      sortType: 0,
      sortKey: '',
    }
    setPageInfo({
      page: 1,
      pageSize: 20,
    })
  }

  const handleSearch = async (data?: any) => {
    if (data) {
      resetPageParmams()
      searchRef.current = data
    }
    if (apiList && apiList.searchApi) {
      const res: any = await http.get(apiList?.searchApi, {params: {...searchRef.current, ...tableRef.current}})
      if (res.result === 0) {
        message.success('查询成功')
        setDataSource(res.data)
        setTotal(res.total)
      } else {
        message.success(res.msg || '网络异常，请重试')
      }
    }
  }
  const onChange = (pagination: any, filter: any, sorter: any, extra: any) => {
    // 排序变动
    if (extra && extra.action === 'sort') {
      tableRef.current = {
        ...tableRef.current,
        page: 1,
        sortType: sorter.order, // 排序类型 ascend：升序 descend: 降序
        sortKey: sorter.field, // 排序字段
      }
      setPageInfo({
        page: 1,
        pageSize: tableRef.current.pageSize,
      })
    }
    // 分页变动
    if (extra && extra.action === 'paginate') {
      tableRef.current = {
        ...tableRef.current,
        page: pagination.current,
        pageSize: pagination.pageSize,
      }
      setPageInfo({
        page: pagination.current,
        pageSize: pagination.pageSize,
      })
    }
    handleSearch()
  }
  const handleExport = async () => {
    if (apiList?.exportApi) {
      const res: any = await http.get(apiList?.exportApi, {params: {...searchRef.current}, responseType: 'blob'})
      exportExcel(res)
      message.success('导出成功!')
    }
  }
  const addForm = () => {
    setshowAddModall(true)
  }
  const handleOkAddModal = async (data: any) => {
    if (apiList && apiList.addApi) {
      const res: any = await http.get(apiList?.addApi, {params: {...data}})
      if (res.result === 0) {
        message.success('新增成功')
        setshowAddModall(false)
        handleSearch()
      } else {
        message.success(res.msg || '网络异常，请重试')
      }
    }
  }
  return (
    <Provider>
      <div className={styles.container}>
        <Search
          data={searchJson}
          submit={handleSearch}
          export={apiList?.exportApi ? handleExport : undefined}
          add={addJson ? addForm : undefined}
        />
        {children}
        <Table
          columns={tableJson.columns}
          dataSource={dataSource}
          onChange={onChange}
          pagination={{pageSize: pageInfo.pageSize, current: pageInfo.page, total, showSizeChanger: false}}
          showSorterTooltip={false}
        />
        <ModalForm
          data={addJson || []}
          open={showAddModal}
          handleOk={handleOkAddModal}
          handleCancel={() => {
            setshowAddModall(false)
          }}
        />
      </div>
    </Provider>
  )
}

export default SchemaForm
